import React from "react";

export const FacetedFilterCheckbox = ({item, group, onFacetChange}) => {
    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={() => onFacetChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {item.label}
                {/*{!isNaN(item.quantity) && item.quantity != null && (*/}
                {/*    <span className="faceted-filter__quantity">*/}
                {/*        &nbsp;({item.quantity})*/}
                {/*    </span>*/}
                {/*)}*/}
            </span>
        </label>
    );
};
